import { render } from "./DesignationEditor.vue?vue&type=template&id=5cd50958"
import script from "./DesignationEditor.vue?vue&type=script&lang=js"
export * from "./DesignationEditor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__